import { render } from "./PlayerDocumentsTab.vue?vue&type=template&id=f0a424be"
import script from "./PlayerDocumentsTab.vue?vue&type=script&lang=js"
export * from "./PlayerDocumentsTab.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__